<template>
  <div
    v-if="checkField('car') && selectedCar"
    class="summary_item_wrapper mb-4 h-max w-min pb-0 md:mb-0 md:pb-[20px]"
  >
    <span class="summary_item_title">Car:</span>
    <div
      :class="smallScreen ? 'flex-col items-start' : 'flex-row items-center'"
      class="flex justify-start"
    >
      <span class="summary_item_input_sibling w-max break-words"
        >{{ selectedCar.slug_class_name }}
      </span>
      <div v-if="!isMobile" class="popup_opened group relative py-2">
        <div
          class="fixed left-1/2 top-1/2 z-40 hidden w-[514px] -translate-x-1/2 -translate-y-1/2 drop-shadow-popup group-hover:block"
        >
          <car-popup-content />
        </div>
        <span class="summary_view_button ml-2 cursor-pointer">View</span>
      </div>
      <div v-if="isMobile" :class="!smallScreen && 'ml-2'" class="py-2 leading-[1]">
        <button @click="$emit('open-modal')" class="summary_view_button">View</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import { useMobile } from '@/compose/ismobile'
import { useCarsStore } from '@/stores'
import CarPopupContent from '@/components/features/car/CarPopupContent.vue'

const { isMobile } = useMobile()
const smallScreen = ref(window.innerWidth <= 450)

const carsStore = useCarsStore()

const { selectedCar } = storeToRefs(carsStore)

defineProps({
  checkField: {
    type: Function,
    required: true
  },
  isModalOpen: {
    type: Boolean,
    default: false
  }
})

defineEmits(['open-modal', 'close-modal'])
</script>
